import Image from "next/image";
import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import React, { useRef, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation } from "swiper/modules";

import BlogAuthor from "./Blog-Author";

const tagKey = (str) =>
  String(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/(^_|_$)/g, "");

const SmartTechBlogDetails = ({ matchedBlog, isSlider, isQuote, isAudio, isVideo }) => {

  const { t } = useTranslation("blog");
  const thumbsSwiperRef = useRef(null);

  const [shareUrl, setShareUrl] = useState("");
  useEffect(() => {
    if (typeof window !== "undefined") setShareUrl(window.location.href);
  }, []);

  const blogImageAlt = t("detail.blogImageAlt", "Blog Images");
  const postId = matchedBlog ? matchedBlog.id : undefined;
  // Guard against calling t() before matchedBlog resolves (e.g. the brief window before
  // router.query is ready on first client render) — otherwise a missing translation with an
  // undefined fallback renders the literal key ("posts.undefined.descOne") instead of blank.
  const pt = (field, fallback) => (matchedBlog ? t(`posts.${postId}.${field}`, fallback) : fallback);
  const title = matchedBlog ? pt("title", matchedBlog.title) : "";

  return (
    <>
      <div className="content">
        {isQuote || isAudio || isVideo ? (
          ""
        ) : (
          <>
            {isSlider ? (
              <div className="post-thumbnail mb--30 position-relative wp-block-image blog-post-gallery-wrapper alignwide">
                <Swiper
                  className="swiper rbt-arrow-between blog-post-gallery-activation"
                  modules={[FreeMode, Navigation]}
                  ref={thumbsSwiperRef}
                  slidesPerView={1}
                  spaceBetween={0}
                  loop={false}
                  autoHeight={true}
                  navigation={{
                    nextEl: ".rbt-arrow-left",
                    prevEl: ".rbt-arrow-right",
                    clickable: true,
                  }}
                >
                  <div className="swiper-wrapper">
                    {matchedBlog &&
                      matchedBlog.gallery.map((item, innerIndex) => (
                        <SwiperSlide className="swiper-slide" key={innerIndex}>
                          <figure>
                            <LazyImage
                              src={item.galleryImg}
                              width={1085}
                              height={645}
                              alt={blogImageAlt}
                            />
                          </figure>
                        </SwiperSlide>
                      ))}
                  </div>
                  <div className="rbt-swiper-arrow rbt-arrow-left">
                    <div className="custom-overfolow">
                      <i className="rbt-icon feather-arrow-left"></i>
                      <i className="rbt-icon-top feather-arrow-left"></i>
                    </div>
                  </div>

                  <div className="rbt-swiper-arrow rbt-arrow-right">
                    <div className="custom-overfolow">
                      <i className="rbt-icon feather-arrow-right"></i>
                      <i className="rbt-icon-top feather-arrow-right"></i>
                    </div>
                  </div>
                </Swiper>
              </div>
            ) : (
              <div className="post-thumbnail mb--30 position-relative wp-block-image alignwide">
                <figure>
                  {matchedBlog.gallery && (
                    <Image
                      src={matchedBlog.gallery[0].galleryImg}
                      width={1085}
                      height={645}
                      priority
                      alt={blogImageAlt}
                    />
                  )}
                  <figcaption>{pt("caption", matchedBlog.caption)}</figcaption>
                </figure>
              </div>
            )}
          </>
        )}

        {isAudio ? (
          <audio className="mb--40" controls>
            <source
              src="http://axilthemes.com/themes/blogar/wp-content/uploads/2021/01/audio.mp3"
              type="audio/ogg"
            />
            {t("detail.audioNotSupported", "Your browser does not support the audio tag.")}
          </audio>
        ) : (
          ""
        )}

        {isVideo ? (
          <div className="ratio ratio-16x9 alignwide mb--30">
            <iframe
              className="square"
              src="https://www.youtube.com/embed/vlDzYIIOYmM"
              title="YouTube video"
              allowFullScreen
            ></iframe>
          </div>
        ) : (
          ""
        )}

        <p>{pt("descOne", matchedBlog.descOne)}</p>
        <blockquote
          className={`${
            isQuote
              ? "rbt-blockquote mt--0 alignwide square rbt-border-none bg-color-gray-light"
              : "wp-block-quote"
          }`}
        >
          <p>{pt("quote", matchedBlog.quote)}</p>
          <cite>&mdash; {pt("quoteAuthor", matchedBlog.quoteAuthor)}</cite>
        </blockquote>
        <div className="wp-block-gallery columns-3 is-cropped">
          <ul className="blocks-gallery-grid">
            {matchedBlog &&
              matchedBlog.gallery.map((item, innerIndex) => (
                <li className="blocks-gallery-item" key={innerIndex}>
                  <figure>
                    {item.galleryImg && (
                      <LazyImage
                        className="radius-4"
                        src={item.galleryImg}
                        width={255}
                        height={143}
                        alt={blogImageAlt}
                      />
                    )}
                  </figure>
                </li>
              ))}
          </ul>
        </div>

        <h4>{pt("titleTwo", matchedBlog.titleTwo)}</h4>
        <p>{pt("descTwo", matchedBlog.descTwo)}</p>
        <p>{pt("descThree", matchedBlog.descThree)}</p>

        <h4>{pt("titleThree", matchedBlog.titleThree)}</h4>
        <p>{pt("descSaven", matchedBlog.descSaven)}</p>

        <div className="post-thumbnail mb--30 position-relative wp-block-image alignwide">
          <figure>
            {matchedBlog.addImg && (
              <LazyImage
                src={matchedBlog.addImg}
                width={1085}
                height={645}
                alt={blogImageAlt}
              />
            )}

            <figcaption>{pt("caption", matchedBlog.caption)}</figcaption>
          </figure>
        </div>

        <p>{pt("descFive", matchedBlog.descFive)}</p>
        <h4>{pt("titleFour", matchedBlog.titleFour)}</h4>
        <p>{pt("descSix", matchedBlog.descSix)}</p>

        <div className="tagcloud">
          {matchedBlog &&
            matchedBlog.tag.map((tagItem, innerIndex) => (
              <span className="rbt-blog-tag-chip" key={innerIndex}>
                {t(`tags.${tagKey(tagItem.tag)}`, tagItem.tag)}
              </span>
            ))}
        </div>

        <div className="social-share-block">
          <span className="b3 share-label">{t("detail.shareLabel", "Share this article")}</span>
          <ul className="social-icon social-default transparent-with-border">
            {matchedBlog &&
              matchedBlog.social.map((socialItem, innerIndex) => {
                const shareHref = shareUrl
                  ? socialItem.icon.includes("facebook")
                    ? `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`
                    : socialItem.icon.includes("twitter")
                    ? `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(title)}`
                    : socialItem.icon.includes("linkedin")
                    ? `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`
                    : "#"
                  : "#";
                return (
                  <li key={innerIndex}>
                    <Link href={shareHref} target="_blank" rel="noopener noreferrer">
                      <i className={socialItem.icon}></i>
                    </Link>
                  </li>
                );
              })}
          </ul>
        </div>

        <div className="about-author">
          {matchedBlog &&
            matchedBlog.author.map((author, innerIndex) => (
              <BlogAuthor {...author} author={author} key={innerIndex} />
            ))}
        </div>
      </div>
    </>
  );
};

export default SmartTechBlogDetails;
